(function () {
    "use strict";

    angular
        .module("app")
        .directive("criticalPathDevPatternList", ["PatternService", "CriticalPathService", criticalPathDevPatternList]);

    function criticalPathDevPatternList(PatternService) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.loadData = function (id) {
                    if (!id) {
                        scope.data = [];
                        return;
                    }

                    PatternService.getPatternCriticalPaths(id).then(function (response) {
                        scope.data = response;
                    });
                }

                scope.loadData(scope.patternSeasonalId);

                scope.$watch("patternSeasonalId", function (newValue, oldValue) {
                    if (newValue !== oldValue)
                        scope.loadData(newValue);
                });

                scope.$watch("updateDirectives", function (newValue) {
                    if (typeof newValue === "undefined")
                        return;
                    scope.loadData(scope.patternSeasonalId);
                });
            },
            scope: { patternSeasonalId: "=", updateDirectives: "=" },
            templateUrl: templateUrl("app/components/criticalPath/devPatternList.directive.html")
        };
    }
})();

